import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-68-kartikeya-hariyani-guest.webp";
import ThumbImg from "../../assets/images/conversations/068.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: kh-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .kh-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  .kh-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 - HERO
  ══════════════════════════════════════ */
  .kh-hero {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .kh-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .kh-hero__left {
    display: flex;
    flex-direction: column;
    gap: 44px;
  }
  .kh-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .kh-hero__title.kh-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .kh-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .kh-hero__spotify.kh-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .kh-hero__spotify iframe {
    display: block;
    width: 100%;
    height: 152px;
    border: none;
    border-radius: 12px;
  }
  .kh-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .kh-hero__right.kh-visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* thumbnail */
  .kh-yt-thumb {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    display: block;
    background: #000;
  }
  .kh-yt-thumb img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .kh-yt-thumb:hover img { opacity: 0.85; }
  .kh-yt-thumb__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .kh-yt-thumb__play img {
    width: 40px;
    height: 44px;
  }
  .kh-yt-iframe-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .kh-yt-iframe-wrap iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 - BODY
  ══════════════════════════════════════ */
  .kh-body {
    padding-bottom: 100px;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .kh-body.kh-visible { opacity: 1; transform: translateY(0); }
  .kh-body__para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }
  .kh-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 - OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .kh-guest {
    padding-bottom: 100px;
    text-align: center;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .kh-guest.kh-visible { opacity: 1; transform: translateY(0); }
  .kh-guest__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 60px;
  }
  .kh-guest__photo-bg {
    display: inline-block;
    width: 445px;
    height: 500px;
    background: #743FAC;
    border-radius: 12px;
    overflow: hidden;
  }
  .kh-guest__photo-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .kh-guest__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .kh-inner { padding-left: 32px; padding-right: 32px; }
    .kh-hero { padding-top: 32px; padding-bottom: 48px; }
    .kh-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .kh-hero__title { font-size: 24px; }
    .kh-hero__left { gap: 16px; }
    .kh-guest__title { font-size: 24px; margin-bottom: 24px; }
    .kh-guest__photo-bg { width: 260px; height: 300px; }
    .kh-guest__name { font-size: 24px; margin-top: 18px; }
    .kh-body__para { font-size: 14px; margin-bottom: 12px; }
    .kh-body { padding-bottom: 48px; }
    .kh-guest { padding-bottom: 48px; }
    .kh-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .kh-inner { padding-left: 16px; padding-right: 16px; }
    .kh-hero { padding-top: 51px; padding-bottom: 30px; }
    .kh-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .kh-hero__left { gap: 30px; }
    .kh-hero__title { font-size: 30px; }
    .kh-body__para { font-size: 16px; margin-bottom: 10px; }
    .kh-guest__title { font-size: 30px; margin-bottom: 20px; text-align:left; }
    .kh-guest__photo-bg { width: 100%; height: 386px; }
    .kh-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .kh-body { padding-bottom: 30px; }
    .kh-guest { padding-bottom: 30px; }
    .kh-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

/* ─────────────────────────────────────────────
   FADE-UP HOOK
───────────────────────────────────────────── */
function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("kh-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

/* ─────────────────────────────────────────────
   YOUTUBE EMBED
───────────────────────────────────────────── */
const YT_VIDEO_ID = "YOUTUBE_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="kh-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 68 Kartikeya Hariyani"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="kh-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 68 Kartikeya Hariyani thumbnail" />
      <div className="kh-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SECTIONS
───────────────────────────────────────────── */
function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);

  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="kh-hero">
      <div className="kh-inner">
        <div className="kh-hero__grid">
          <div className="kh-hero__left">
            <h1 ref={titleRef} className="kh-hero__title">
              EP 68 | India's EV charging story is entering its toughest phase: execution | Kartikeya Hariyani, Founder & CEO of ChargeZone
            </h1>
            <div ref={spotifyRef} className="kh-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/4SEZcXMJ8V5VUlfkhiZisJ?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 68 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="kh-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="kh-body">
      <div className="kh-inner">
        <p className="kh-body__para">
          Five years ago, EV charging in India was a promise… today, it's a battlefield.
        </p>
        <p className="kh-body__para">
          Billions of dollars committed, networks being built at speed, and yet, range anxiety, broken chargers, and questions on profitability still linger. The hype phase is over. This is now about execution, resilience, and who actually survives the decade.
        </p>
        <p className="kh-body__para">
          My guest today isn't theorising about this transition. He's building it. Brick by brick. Charger by charger.
        </p>
        <p className="kh-body__para">
          For the third time on Energizing India, I'm joined by Kartikey Hariyani, founder and CEO of ChargeZone, one of India's largest independent EV charging networks, taking on giants and redefining what scale looks like in this space.
        </p>
        <p className="kh-body__para">
          Kartikey, welcome back. This one's going to be fun.
        </p>
        <p className="kh-body__para">
          In this podcast Episode, Chargezone CEO Kartik Harani discusses the rapid maturation of India's electric vehicle charging sector as it transitions from a growth phase to an execution-focused grid. He debunks the misconception that network size equals success, emphasizing instead that energy sales, reliability, and supercharging capabilities are the true drivers of profitability. Harani highlights Chargezone's shift toward ultra-fast intercity infrastructure and its 'open access' strategy that serves both personal cars and commercial fleets. The conversation also explores how India can achieve national energy security by following China's integrated approach to electrification, particularly through subsidizing electric trucks. Looking toward 2030, Harani envisions a consolidated market where traditional banking capital and innovative franchise models fuel expansion. He concludes by sharing his bold vision for sustainable microgrids, aiming to control the entire lifecycle of an electron from solar generation to vehicle propulsion.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="kh-guest">
      <div className="kh-inner">
        <h2 className="kh-guest__title">Our Guest</h2>
        <div>
          <div className="kh-guest__photo-bg">
            <img src={GuestImg} alt="Kartikeya Hariyani" />
          </div>
          <p className="kh-guest__name">Kartikey HARIYANI</p>
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Ep68KartikeyaHariyani() {
  return (
    <>
      <style>{CSS}</style>
      <div className="kh-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}